// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1rCJm","col":"styles_col__3dtAz"};